import axios from "axios";
import { apiDomain } from "../../store/constants";

const Auth = {
  login(data) {
    return axios({
      url: apiDomain + `login`,
      method: "POST",
      data: data.payload,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  logout() {
    return axios({
      url: apiDomain + `logout`,
      method: "POST",
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  getUser() {
    return axios({
      url: apiDomain + `api/user`,
      method: "GET",
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  getMasterRegister() {
    return axios({
      url: apiDomain + `register/create`,
      method: "GET",
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  register(data) {
    return axios({
      url: apiDomain + `register`,
      method: "POST",
      data,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  getUsers(payload) {
    return axios({
      url: apiDomain + `api/users`,
      method: "GET",
      params: payload,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },

  show(id) {
    return axios({
      url: apiDomain + `api/users/${id}`,
      method: "GET",
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },

  create(params) {
    return axios({
      url: apiDomain + `api/users/create`,
      method: "GET",
      params: params,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },

  store(data) {
    return axios({
      url: apiDomain + `api/users`,
      method: "POST",
      data: data,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },

  edit(data) {
    return axios({
      url: apiDomain + `api/users/${data.id}/edit`,
      method: "GET",
      params: data,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },

  update(payload) {
    return axios({
      url: apiDomain + `api/users/${payload.id}`,
      method: "PUT",
      data: payload.data,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },

  delete(id) {
    return axios({
      url: apiDomain + `api/users/${id}`,
      method: "DELETE",
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },

  getLogActivities(payload) {
    return axios({
      url: apiDomain + `api/log-activities`,
      method: "GET",
      params: payload,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },

  forgotPassword(payload) {
    return axios({
      url: apiDomain + `api/forgot-password`,
      method: "POST",
      data: payload,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },

  resetPassword(payload) {
    return axios({
      url: apiDomain + `api/reset-password`,
      method: "POST",
      data: payload,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
};

export default Auth;
